import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface createGoogleMapState {
  isLoaded?: boolean;
}

const initialState: createGoogleMapState = {
  isLoaded: false,
};

export const createGoogleMapSlice = createSlice({
  name: "googleMap",
  initialState,
  reducers: {
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    resetGoogleMapState: () => initialState,
  },
});

export const { setIsLoaded, resetGoogleMapState } =
  createGoogleMapSlice.actions;

export default createGoogleMapSlice.reducer;
